<template>
    <div>
        <Breadcrumbs main="Admin" submain="" title="Admin" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div style="max-width: fit-content;"> 
                                <router-link to="/admin/register">
                                    <button class="btn btn-primary" type="submit" style="display: flex; gap: 12px; align-items: center;">
                                        <i class="fa fa-light fa-plus"></i>
                                        <h7>Add New Admin</h7>
                                    </button>
                                </router-link>
                            </div>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="admin_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(user_name)="row">
                                            <div v-if="row.item.user_name">
                                                <p>{{ row.item.user_name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(email)="row">
                                            <div v-if="row.item.email">
                                                <p>{{ row.item.email }}</p>
                                            </div>
                                        </template>

                                        <template #cell(nid)="row">
                                            <div v-if="row.item.additional_info">
                                                <p>{{ row.item.additional_info.nid }}</p>
                                            </div>
                                        </template>

                                        <template #cell(phone_number)="row">
                                            <div v-if="row.item.additional_info">
                                                <p>{{ row.item.additional_info.phone_number }}</p>
                                            </div>
                                        </template>

                                        <template #cell(photo)="row">
                                            <div v-if="row.item.additional_info">
                                                <img style="height: 70px;" :src="host + row.item.additional_info.photo" alt="">
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteAdmin(data.item.id)" title="Delete"></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Admin Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this admin?</div>
        </b-modal>
    </div>
    </template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    import Multiselect from 'vue-multiselect';
    
    export default {
        components: {
            loader,
            Multiselect
        },
    
        data() {
            return {
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'user_name',
                        label: 'Admin',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        sortable: true
                    },
                    {
                        key: 'nid',
                        label: 'Nid No.',
                        sortable: true
                    },
                    {
                        key: 'phone_number',
                        label: 'Phone No.',
                        sortable: true
                    },
                    {
                        key: 'photo',
                        label: 'Image',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
                delete_value: null,
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                admin_list: state => state.admin.admin,
                loading: state => state.admin.adminLoading,
                error: state => state.admin.adminError
            })
        },
    
        mounted() {
            this.$store.dispatch("admin/fetchAdmin").then(() => {
                this.items = this.admin_list
                this.totalRows = this.admin_list.length;
            });
        },
    
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            deleteAdmin(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("admin/deleteAdmin", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    